import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

type UseCompetitionRegistrationListQueryParams = Exclude<Parameters<typeof SSF.api.registrationsList>, undefined>[0];

export const keys = createQueryKeySet<UseCompetitionRegistrationListQueryParams>('registrations');

export function useCompetitionRegistrationListQuery(params?: UseCompetitionRegistrationListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.registrationsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}

export function useCompetitionRegistrationDetailQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.registrationsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
    enabled: !!id,
  });
}
